import { useTranslation } from "@redotech/redo-i18n";
import { LoyaltyEarnedMeasureOption } from "@redotech/redo-return-core-common/return-flow/condition-enums";
import type { LoyaltyEarnedState } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import {
  RadioGroupOption,
  RedoRadioGroup,
} from "@redotech/redo-web/arbiter-components/radio/redo-radio-group";
import { memo } from "react";

function measureOptions(
  t: (key: string) => string,
): RadioGroupOption<LoyaltyEarnedMeasureOption>[] {
  return [
    { id: LoyaltyEarnedMeasureOption.PERCENT, label: "%" },
    { id: LoyaltyEarnedMeasureOption.AMOUNT, label: t("Raw amount") },
  ];
}

export const LoyaltyEarnedDetails = memo(function LoyaltyEarnedDetails({
  state,
  setState,
}: ConditionTypeDetailsProps<LoyaltyEarnedState>) {
  const { t } = useTranslation();
  return (
    <>
      <RedoRadioGroup
        options={measureOptions(t)}
        setValue={(measureOption) => setState({ ...state, measureOption })}
        size="xs"
        value={state.measureOption}
      />
      <RedoTextInput
        inputTypeHint="number"
        label={t("Value")}
        max={
          state.measureOption === LoyaltyEarnedMeasureOption.PERCENT
            ? 100
            : undefined
        }
        min={0}
        setValue={(e) => {
          setState({ ...state, value: +e });
        }}
        size="sm"
        value={state.value.toString()}
      />
    </>
  );
});
